import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { accessory } from './Reducers/Accessory.reducer';
import { sentryDsn } from './Reducers/Sentry.reducer';
import overlaySlice from './Slices/OverlaySlice';

const staticReducers = {
  cart,
  myPage,
  quickSearch,
  navigation,
  facetedSearch,
  checkout,
  accessory,
  sentryDsn,
  overlaySlice,
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
};

export default app;
